import { inject, Injectable } from '@angular/core';
import { DataContextService } from '@seahorse/common';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ContentDistributionDataServiceBase {
  protected dataContext = inject(DataContextService);

  applyTemplateContent(
    template: string,
    templateId?: number,
    mappingKey?: string,
    objectIds?: string[],
    data?: string
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ): Observable<any> {
    const url = 'contentdistribution/apply-content';
    return this.dataContext.post(url, {
      template: template,
      templateId: templateId,
      mappingKey: mappingKey,
      objectIds: objectIds,
      data: data,
    });
  }
}
